import type { ThunkAction, ThunkDispatch } from 'redux-thunk'
import type { Action } from '@reduxjs/toolkit'
import { configureStore } from '@reduxjs/toolkit'
import type { RootState } from '@/store/rootReducer'
import rootReducer from '@/store/rootReducer'
import type { TypedUseSelectorHook } from 'react-redux'
import { useSelector as useReduxSelector, useDispatch as useReduxDispatch } from 'react-redux'

// 全局store
const store = configureStore({
  reducer: rootReducer,

  devTools: process.env.NODE_ENV !== 'production',
})

// 热重载
if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./rootReducer', () => {
    /* eslint-disable-next-line @typescript-eslint/no-var-requires */
    const newRootReducer = require('./rootReducer').default
    store.replaceReducer(newRootReducer)
  })
}

// 最原始的getState
export type AppGetState = typeof store.getState

// 最原始的dispatch
export type AppDispatch = typeof store.dispatch

// It is important to use Action as last type argument, does not work with any.
export type AppThunkDispatch = ThunkDispatch<RootState, undefined, Action>

// 给dispatch加上type
export const useDispatch = (): AppThunkDispatch => useReduxDispatch<AppThunkDispatch>()

// 给useSelector加上rootState的默认type
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector

// 同步action的type
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>

// 异步action的type
export type AsyncAppThunk<ReturnType = void> = ThunkAction<Promise<ReturnType>, RootState, unknown, Action<string>>

export default store
